import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import TabItem from "./components/TabItem";
import getNextFocusedTabIndex from "./helpers/getNextFocusedTabIndex";
import Props, { TabProps } from "./types";
import styles from './TabToggle.module.scss';
const getTabItems = (parent, selector = 'button') => parent === null || parent === void 0 ? void 0 : parent.querySelectorAll(selector);
const TabToggle = ({ activeTabStyle, tabs, className, tabContentClassName, setSelectedTab, defaultOpenTab, rememberTabChildrenState, tabButtonStripThickness, setHasTabChanged, }) => {
    const list = useRef(null);
    const focusedTab = useRef(0);
    const [isOpen, setIsOpen] = useState(defaultOpenTab || tabs[0].id);
    useEffect(() => {
        var _a;
        focusedTab.current = defaultOpenTab ? tabs.findIndex((tab) => tab.id === defaultOpenTab) : 0;
        const tabItems = getTabItems(list.current);
        (_a = list.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', (e) => {
            const focusedTabCandidate = getNextFocusedTabIndex(focusedTab.current, e.key, tabItems);
            if (focusedTabCandidate !== -1) {
                tabItems[focusedTab.current].setAttribute('tabindex', '-1');
                tabItems[focusedTabCandidate].setAttribute('tabindex', '0');
                tabItems[focusedTabCandidate].focus();
                focusedTab.current = focusedTabCandidate;
            }
        });
    }, []);
    const handleOnClick = (tab, index) => {
        focusedTab.current = index;
        setIsOpen(tab.id);
        setSelectedTab === null || setSelectedTab === void 0 ? void 0 : setSelectedTab(tab.id);
        setHasTabChanged === null || setHasTabChanged === void 0 ? void 0 : setHasTabChanged(true);
    };
    const tabTriggers = tabs.map((tab, index) => (React.createElement(TabItem, { activeTabStyle: activeTabStyle, tab: tab, isOpen: isOpen === tab.id, handleClick: () => handleOnClick(tab, index), key: tab.id, stripThickness: tabButtonStripThickness })));
    const openTab = tabs.find((tab) => tab.id === isOpen);
    if (!openTab)
        return null;
    return (React.createElement("div", { className: className },
        React.createElement("div", { ref: list, className: styles.tabContainer, role: "tablist" }, tabTriggers),
        React.createElement("div", { tabIndex: 0, className: cn(styles.content, tabContentClassName), role: "tabpanel", id: `tabpanel-${openTab.id}`, "aria-labelledby": openTab.id }, rememberTabChildrenState ? (React.createElement(React.Fragment, null, tabs.map((tab) => (React.createElement("div", { hidden: tab.id !== openTab.id, key: tab.id }, tab.children))))) : (React.createElement(React.Fragment, null, openTab.children)))));
};
export default TabToggle;
//# sourceMappingURL=TabToggle.js.map